import { render, staticRenderFns } from "./indexMenu.vue?vue&type=template&id=88132f6c&"
import script from "./indexMenu.vue?vue&type=script&lang=js&"
export * from "./indexMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports